var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPatientSilhouette = function SvgPatientSilhouette(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-12513.5 -2202.5 43.1 42.976",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #dadada;\n      }\n\n      .cls-2 {\n        fill: #dadada;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group-89",
    transform: "translate(-12513 -2202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse-19",
    className: "cls-1",
    d: "M21.05,0A20.988,20.988,0,1,1,0,20.988,21.019,21.019,0,0,1,21.05,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "group-66",
    transform: "translate(5.907 8.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-64",
    className: "cls-2",
    d: "M15.142,33.648A20.909,20.909,0,0,1,0,27.239c3.272-6,8.994-9.582,15.309-9.582,6.216,0,11.892,3.5,15.183,9.355A21.148,21.148,0,0,1,20.1,33.062,20.907,20.907,0,0,1,15.142,33.648Zm0-18.323a7.662,7.662,0,1,1,7.685-7.663A7.682,7.682,0,0,1,15.142,15.325Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPatientSilhouette, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/patientSilhouette.03dacdca.svg";
export { ForwardRef as ReactComponent };